module.exports = __webpack_public_path__ + "img/beijing1.af3849a9.svg";